(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aman-offer-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aman-offer-strip')) {
    customElements.define('aman-offer-strip', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.aman-offers__track');
        if (!this.track || this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches || !!window.Shopify?.designMode;
        this.visible = false;
        this.track.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') this.hovered = true; }, options);
        this.track.addEventListener('pointerleave', () => { this.hovered = false; }, options);
        this.track.addEventListener('touchstart', () => { this.touching = true; this.interacted(); }, { ...options, passive: true });
        this.track.addEventListener('touchend', () => { this.touching = false; this.interacted(); }, { ...options, passive: true });
        this.track.addEventListener('touchcancel', () => { this.touching = false; this.interacted(); }, { ...options, passive: true });
        this.track.addEventListener('wheel', () => this.interacted(), { ...options, passive: true });
        this.track.addEventListener('keydown', () => this.interacted(), options);
        this.track.addEventListener('focusout', () => this.interacted(), options);
        this.addEventListener('shopify:block:select', event => {
          this.paused = true;
          event.target.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'start' });
        }, options);
        this.motion.addEventListener('change', event => {
          if (event.matches) this.paused = true;
        }, options);
        this.observer = new ResizeObserver(() => {
          if (this.lastWidth !== this.track.clientWidth) this.rebuild();
        });
        this.observer.observe(this.track);
        this.visibility = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; });
        this.visibility.observe(this);
        this.rebuild();
        this.tick = time => {
          const elapsed = Math.min(time - (this.lastTime || time), 64);
          this.lastTime = time;
          const stopped = this.dataset.autoplay !== 'true' || this.paused || this.hovered || this.touching || document.hidden || !this.visible || this.track.contains(document.activeElement) || time < (this.resumeAt || 0);
          if (stopped) {
            this.position = Math.abs(this.track.scrollLeft);
          } else if (this.cycleWidth > 0) {
            this.position = (this.position + elapsed * (Number(this.dataset.speed) || 35) / 1000) % this.cycleWidth;
            this.track.scrollLeft = this.rtl ? -this.position : this.position;
          }
          this.frame = requestAnimationFrame(this.tick);
        };
        this.frame = requestAnimationFrame(this.tick);
      }
      interacted() {
        this.resumeAt = performance.now() + 2500;
        this.position = Math.abs(this.track.scrollLeft);
      }
      rebuild() {
        this.track.querySelectorAll('[data-offer-clone]').forEach(item => item.remove());
        const items = [...this.track.children];
        this.lastWidth = this.track.clientWidth;
        this.rtl = getComputedStyle(this.track).direction === 'rtl';
        this.cycleWidth = items.reduce((width, item) => width + item.getBoundingClientRect().width, 0);
        if (this.dataset.autoplay === 'true' && this.cycleWidth > 0) {
          const repetitions = Math.ceil(this.track.clientWidth / this.cycleWidth) + 1;
          for (let i = 0; i < repetitions; i++) {
            items.forEach(item => {
              const clone = item.cloneNode(true);
              clone.dataset.offerClone = '';
              clone.setAttribute('aria-hidden', 'true');
              clone.removeAttribute('data-shopify-editor-block');
              [clone, ...clone.querySelectorAll('[id], [tabindex], a, button, input')].forEach(node => {
                node.removeAttribute('id');
                node.setAttribute('tabindex', '-1');
              });
              clone.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
              this.track.append(clone);
            });
          }
        }
        this.position = 0;
        this.track.scrollLeft = 0;
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.visibility?.disconnect();
        this.abort?.abort();
        this.track?.querySelectorAll('[data-offer-clone]').forEach(item => item.remove());
        this.abort = null;
        this.lastTime = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["entry-offer-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-entry-offer-popup]';

    function storageKey(dialog) {
      return `entry-offer-popup:${dialog.dataset.sectionId}`;
    }

    function isDismissed(dialog) {
      try {
        return sessionStorage.getItem(storageKey(dialog)) === 'dismissed';
      } catch (error) {
        return false;
      }
    }

    function rememberDismissal(dialog) {
      if (dialog.dataset.designMode === 'true') return;
      try {
        sessionStorage.setItem(storageKey(dialog), 'dismissed');
      } catch (error) {
        // Storage can be unavailable in privacy-restricted browsers.
      }
    }

    function closePopup(dialog) {
      rememberDismissal(dialog);
      if (dialog.open) dialog.close();
    }

    function openPopup(dialog) {
      const homeOnly = dialog.dataset.homeOnly === 'true';
      const isHome = dialog.dataset.isHome === 'true';
      const designMode = dialog.dataset.designMode === 'true';
      if ((!designMode && isDismissed(dialog)) || (homeOnly && !isHome)) return;
      if (!dialog.open) dialog.showModal();
    }

    function initialise(dialog) {
      if (dialog.dataset.initialised === 'true') return;
      dialog.dataset.initialised = 'true';

      dialog.querySelectorAll('[data-entry-popup-close]').forEach((button) => {
        button.addEventListener('click', () => closePopup(dialog));
      });

      dialog.querySelectorAll('[data-entry-popup-cta]').forEach((link) => {
        link.addEventListener('click', () => rememberDismissal(dialog));
      });

      const codeButton = dialog.querySelector('[data-entry-popup-code]');
      if (codeButton) {
        codeButton.addEventListener('click', async () => {
          const code = codeButton.dataset.entryPopupCode;
          const action = codeButton.querySelector('[data-entry-popup-code-action]');
          try {
            await navigator.clipboard.writeText(code);
            if (action) action.textContent = 'Copied';
            window.setTimeout(() => {
              if (action) action.textContent = 'Copy';
            }, 1800);
          } catch (error) {
            if (action) action.textContent = code;
          }
        });
      }

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closePopup(dialog);
      });

      dialog.addEventListener('cancel', () => rememberDismissal(dialog));

      const delay = Number.parseInt(dialog.dataset.delay, 10) || 0;
      window.setTimeout(() => openPopup(dialog), delay);
    }

    function initialiseAll(root = document) {
      root.querySelectorAll(selector).forEach(initialise);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAll());
    } else {
      initialiseAll();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
    document.addEventListener('shopify:section:select', (event) => {
      const dialog = event.target.querySelector(selector);
      if (dialog && !dialog.open) dialog.showModal();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantiq-home-teaser"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vantiq-home-feature')) {
    customElements.define('vantiq-home-feature', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.track = this.querySelector('[data-vqr-track]');
        if (!this.track) return;
        this.cards = Array.from(this.track.querySelectorAll('[data-vqr-card]'));
        this.previous = this.querySelector('[data-vqr-prev]');
        this.next = this.querySelector('[data-vqr-next]');
        this.dots = this.querySelector('[data-vqr-dots]');
        this.pages = [];
        this.pageIndex = 0;
        this.previous?.addEventListener('click', () => this.go(this.pageIndex - 1), {signal});
        this.next?.addEventListener('click', () => this.go(this.pageIndex + 1), {signal});
        this.track.addEventListener('scroll', () => this.updatePosition(), {signal, passive: true});
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(this.pageIndex + (event.key === 'ArrowRight' ? 1 : -1));
          }
          if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.go(event.key === 'Home' ? 0 : this.pages.length - 1);
          }
        }, {signal});
        this.querySelectorAll('[data-vqr-variant]').forEach(select => {
          let previousPrice = select.selectedOptions[0]?.dataset.price;
          select.addEventListener('change', () => {
            const card = select.closest('[data-vqr-card]');
            const price = card.querySelector('[data-vqr-price]');
            const option = select.selectedOptions[0];
            if (price && option && option.dataset.price !== previousPrice) price.textContent = option.dataset.price;
            previousPrice = option?.dataset.price;
          }, {signal});
        });
        this.resize = new ResizeObserver(() => this.buildPages());
        this.resize.observe(this.track);
        document.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('[data-vqr-card]');
          if (card && this.contains(card)) card.scrollIntoView({block: 'nearest', inline: 'start', behavior: 'instant'});
        }, {signal});
        this.buildPages();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
      }
      buildPages() {
        if (!this.cards.length || !this.track.clientWidth) return;
        const first = this.cards[0];
        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const visible = Math.max(1, Math.round((this.track.clientWidth + gap) / (first.offsetWidth + gap)));
        const pages = [];
        for (let index = 0; index < this.cards.length; index += visible) pages.push(Math.min(index, Math.max(0, this.cards.length - visible)));
        this.pages = Array.from(new Set(pages));
        const enabled = this.pages.length > 1;
        if (this.previous) this.previous.hidden = !enabled;
        if (this.next) this.next.hidden = !enabled;
        if (this.dots) {
          this.dots.replaceChildren();
          if (enabled) this.pages.forEach((_, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'vqr__dot';
            dot.setAttribute('aria-label', this.dots.dataset.label + ' ' + (index + 1));
            dot.setAttribute('aria-controls', this.track.id);
            dot.addEventListener('click', () => this.go(index), {signal: this.abort.signal});
            this.dots.append(dot);
          });
        }
        this.updatePosition();
      }
      go(index) {
        const target = Math.max(0, Math.min(index, this.pages.length - 1));
        const card = this.cards[this.pages[target]];
        if (!card) return;
        this.track.scrollTo({left: card.offsetLeft - this.cards[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      updatePosition() {
        if (!this.pages.length) return;
        let nearest = 0;
        let distance = Infinity;
        this.pages.forEach((cardIndex, index) => {
          const offset = this.cards[cardIndex].offsetLeft - this.cards[0].offsetLeft;
          const current = Math.abs(this.track.scrollLeft - offset);
          if (current < distance) { nearest = index; distance = current; }
        });
        this.pageIndex = nearest;
        if (this.previous) this.previous.disabled = nearest === 0;
        if (this.next) this.next.disabled = nearest === this.pages.length - 1;
        this.dots?.querySelectorAll('button').forEach((dot, index) => dot.setAttribute('aria-current', String(index === nearest)));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantiq-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vantiq-slideshow')) {
    customElements.define('vantiq-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-vq-slide]')];
        if (this.slides.length < 2) return;
        this.index = 0;
        this.paused = false;
        this.hovered = false;
        this.focused = false;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.querySelector('[data-vq-prev]').addEventListener('click', () => this.show(this.index - 1), options);
        this.querySelector('[data-vq-next]').addEventListener('click', () => this.show(this.index + 1), options);
        this.querySelector('[data-vq-pause]').addEventListener('click', (event) => {
          this.paused = !this.paused;
          event.currentTarget.setAttribute('aria-pressed', String(this.paused));
        }, options);
        this.addEventListener('mouseenter', () => this.hovered = true, options);
        this.addEventListener('mouseleave', () => this.hovered = false, options);
        this.addEventListener('focusin', () => this.focused = true, options);
        this.addEventListener('focusout', (event) => this.focused = this.contains(event.relatedTarget), options);
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) { this.show(index); this.paused = true; }
        }, options);
        if (this.dataset.autoplay === 'true' && !window.Shopify?.designMode && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.timer = setInterval(() => {
            if (!this.paused && !this.hovered && !this.focused && !document.hidden) this.show(this.index + 1);
          }, Number(this.dataset.interval) || 5000);
        }
      }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, position) => { slide.hidden = position !== this.index; slide.inert = position !== this.index; });
        this.querySelector('[data-vq-position]').textContent = `${this.index + 1} / ${this.slides.length}`;
      }
      disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
